<template>
  <Popover>
    <PopoverButton
        ref="reference"
        class="flex justify-center items-center rounded-md h-10 w-fit px-4 ring-1 ring-black/20 gap-2 focus-within hover-button"
    >
      <span>Umkreis</span>
      <span class="text-sm text-black/60">{{ range }} km</span>
    </PopoverButton>

    <PopupTransition>
      <teleport to="body">
        <PopoverPanel
            ref="floating"
            class="fixed z-[3000] p-4 glass-background w-[450px] h-fit rounded-md"
            :style="floatingStyles"
        >
          <div class="flex justify-between items-center mb-4">
            <h3 class="popup-title">Umkreis</h3>
            <button
                class="text-sm text-black/60 hover:text-black"
                @click="range = min"
            >
              Zurücksetzen
            </button>
          </div>

          <div class="flex flex-col gap-2">
            <input
                type="range"
                min="5"
                max="100"
                step="5"
                v-model="range"
                :style="sliderStyle"
                class="range-slider w-full cursor-pointer"
            />

            <div class="flex justify-between text-sm text-black/60">
              <span>5 km</span>
              <span>{{ range }} km</span>
              <span>100 km</span>
            </div>
          </div>
        </PopoverPanel>
      </teleport>
    </PopupTransition>
  </Popover>
</template>

<script setup>
import { Popover, PopoverButton, PopoverPanel} from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import {FunnelIcon} from "@heroicons/vue/24/outline";
import { useFloating, offset, flip, shift } from '@floating-ui/vue'
import {computed, ref, defineProps, watch, defineEmits } from "vue";
import { autoUpdate } from '@floating-ui/vue'
import PopupTransition from "@/components/ui/PopupTransition.vue";

const emit = defineEmits(['update:modelValue'])

const reference = ref(null)
const floating = ref(null);
const { floatingStyles } = useFloating(reference, floating, {
  placement: 'bottom',
  middleware: [
    offset(8),
    flip(),
    shift({ padding: 8 }),
  ],
})

const range = ref(5)
const min = 5
const max = 100

const sliderStyle = computed(() => {
  const percent = ((range.value - min) / (max - min)) * 100

  return {
    background: `linear-gradient(
      to right,
      #000 ${percent}%,
      rgba(0,0,0,0.15) ${percent}%
    )`
  }
})

watch(() => range.value, (newValue) => {
  emit('update:modelValue', newValue)
}, { immediate: true });


</script>

<style scoped>
.range-slider {
  -webkit-appearance: none;
  height: 6px;
  border-radius: 9999px;
}

/* Track (Firefox) */
.range-slider::-moz-selectedRange-track {
  height: 6px;
  border-radius: 9999px;
}

/* Thumb */
.range-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 16px;
  width: 16px;
  border-radius: 9999px;
  background: black;
  cursor: pointer;
  margin-top: .5px;
}

.range-slider::-moz-selectedRange-thumb {
  height: 16px;
  width: 16px;
  border-radius: 9999px;
  background: black;
  cursor: pointer;
}

</style>
